/**
 * A name, made safe to put in a downloaded file's name.
 *
 * A name someone will look for in their downloads later: ASCII, no spaces,
 * bounded.
 *
 * Accents are FOLDED (`Ingénierie` → `Ingenierie`) rather than dropped, which
 * the bare strip alone would turn into `Ingnierie` — the company and product
 * names here are routinely French. The strip runs BEFORE the truncation, so everything
 * left to cut is single-code-unit ASCII: there is no multibyte sequence for
 * `substring` to cut in half.
 */
export function sanitizeFilename(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_\-\s]/g, '')
    .replace(/\s+/g, '_')
    .substring(0, 50)
}
